/**
 * /windows-hosting — migrated from public/js/windows-hosting.js.
 * Sticky bookmarks + .loc-menu switch + .features-menu fade + popup-card overlay.
 */
import { Resort } from '../core/resort.js';
import { initStickyBookmarks } from '../shared/sticky-bookmarks.js';

new Resort(() => {
    initStickyBookmarks();

    let switchReady = true;
    ($('.loc-menu') as Element | null)?.on('click', 'a', function (this: Element) {
        if (!switchReady) return;
        switchReady = false;
        this.siblings('.active', (item: Element) => { item.classList.remove('active'); return true; });
        this.classList.add('active');

        $('.layer-1 .price.active', (price: Element) => {
            price.classList.add('fade-out-fast');
            price.addEventListener('animationend', function (this: Element, e: Event) {
                e.stopPropagation();
                this.classList.remove('active', 'fade-out-fast');
            }, { once: true });
            return true;
        });

        const id = (this as HTMLElement).dataset['id'] ?? '';
        $('.layer-1 .btn-order', (button: Element) => {
            const href = (button as HTMLElement).dataset[id];
            if (href) button.setAttribute('href', href);
            return true;
        });

        $(`.layer-1 .price[data-id="${id}"]`, (layer: Element) => {
            layer.classList.add('active', 'fade-in-fast');
            layer.addEventListener('animationend', function (this: Element, e: Event) {
                e.stopPropagation();
                this.classList.remove('fade-in-fast');
                switchReady = true;
            }, { once: true });
            return true;
        });
    });

    ($('.layer-2') as Element | null)?.on('click', '.btn-more', function (this: Element) {
        ($('.more-details') as HTMLElement | null)?.slideDown();
        (this as HTMLElement).style.display = 'none';
    });

    let busy = false;
    ($('.features-menu') as Element | null)?.on('click', 'a', function (this: Element) {
        if (busy) return;
        busy = true;
        this.siblings('a', (item: Element) => { item.classList.remove('active'); return true; });
        this.classList.add('active');

        const activeLayer = $('.layer-5 .text.active') as Element | null;
        activeLayer?.classList.add('fade-out-fast');
        const id = (this as HTMLElement).dataset['id'];

        activeLayer?.addEventListener('animationend', function (this: Element) {
            this.classList.remove('active', 'fade-out-fast');
            const selectedLayer = $(`.layer-5 .text-${id}`) as HTMLElement | null;
            selectedLayer?.css('opacity', '0');
            selectedLayer?.classList.add('active', 'fade-in-fast');
            selectedLayer?.addEventListener('animationend', function (this: HTMLElement) {
                this.classList.remove('fade-in-fast');
                this.css('opacity', '');
                busy = false;
            }, { once: true });
        }, { once: true });
    });

    /* Popup-card overlay */
    const cardDetails = $('.popup-card') as HTMLElement | null;
    let popupOpened = false;

    const popupClose = (): void => {
        if (!popupOpened || !cardDetails) return;
        document.body.style.overflow = 'auto';
        popupOpened = false;
        cardDetails.classList.add('fade-out');
        cardDetails.addEventListener('animationend', function (this: HTMLElement) {
            this.classList.remove('fade-out');
            this.classList.add('hide');
        }, { once: true });
    };

    cardDetails?.on('click', '.close-popup', function (e: Event) {
        e.preventDefault();
        popupClose();
    });

    ($('.layer-4') as Element | null)?.on('click', '.btn-view', () => {
        if (!cardDetails) return;
        document.body.style.overflow = 'hidden';
        cardDetails.classList.add('fade-in');
        cardDetails.classList.remove('hide');
        cardDetails.addEventListener('animationend', function (this: HTMLElement) {
            this.classList.remove('fade-in');
            popupOpened = true;
        }, { once: true });
    });

    window.addEventListener('keyup', (e: KeyboardEvent) => {
        if (e.keyCode === 27 && popupOpened) popupClose();
    });
});
